/**
 * mirrorScore — één antwoord spiegelen binnen de schaal van zijn vraag
 *
 * Negatief geformuleerde matrixrijen ("Ik spreek slecht Nederlands") moeten
 * omgeklapt worden voordat ze met positieve rijen gemiddeld kunnen worden,
 * anders trekt een verbetering het gemiddelde omlaag. De formule stond los
 * ingebakken in computeMsiEffectValue en buildMsiResearchDataset; dit is de
 * gedeelde versie, zodat een derde afnemer niet opnieuw begint.
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 * AI-CONTEXT: See docs/pitfalls.md#database-raw-input-skips-negative-mirroring
 *
 * Let op: midden op de schaal levert spiegelen dezelfde waarde op
 * (1 + 5 − 3 = 3). De valentie van een rij is dus NIET af te leiden uit het
 * verschil tussen ruw en gespiegeld — lees `posNeg` van de rij.
 *
 * @param {number|string|null|undefined} value - Ruwe `Input` (als tekst opgeslagen).
 * @param {{lowerScale?: number|string, upperScale?: number|string}} scale - Veldgrenzen (ReachStart/ReachEnd).
 * @param {boolean} isNegative - Of de rij negatief geformuleerd is.
 * @returns {number|null} De score, of null als er geen getal in zit.
 */
const mirrorScore = (value, scale, isNegative) => {
    if (value === '' || value == null) return null;
    const num = Number(value);
    if (!Number.isFinite(num)) return null;
    if (!isNegative) return num;

    // Legacy-documenten dragen de grenzen soms als tekst; '1' + 5 − 4 zou
    // aaneenplakken in plaats van rekenen.
    const lower = Number(scale?.lowerScale ?? 0);
    const upper = Number(scale?.upperScale ?? 5);
    const safeLower = Number.isFinite(lower) ? lower : 0;
    const safeUpper = Number.isFinite(upper) ? upper : 5;

    return safeLower + safeUpper - num;
};

export default mirrorScore;
